import { Box, Stack, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export default function SentStep() {
  return (
    <Stack alignItems="center" spacing={2} py={2}>
      <Box
        sx={{
          position: 'relative',
          width: 88,
          height: 88,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#00A86B',
          color: 'common.white',
          animation: 'guestReceiptPop 380ms cubic-bezier(0.2, 0.9, 0.3, 1.2)',
          boxShadow:
            '0 20px 40px -12px rgba(0, 168, 107, 0.5), 0 0 0 12px rgba(206, 238, 227, 0.6)',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: -14,
            borderRadius: '50%',
            border: '1px solid rgba(0, 168, 107, 0.25)',
            animation: 'guestReceiptRing 900ms ease-out forwards',
          },
          '@keyframes guestReceiptPop': {
            '0%': { transform: 'scale(0.4)', opacity: 0 },
            '60%': { transform: 'scale(1.06)', opacity: 1 },
            '100%': { transform: 'scale(1)', opacity: 1 },
          },
          '@keyframes guestReceiptRing': {
            '0%': { transform: 'scale(0.6)', opacity: 0.8 },
            '100%': { transform: 'scale(1.6)', opacity: 0 },
          },
        }}>
        <CheckRoundedIcon sx={{ fontSize: 48 }} />
      </Box>
      <Typography
        variant="h2"
        sx={{
          fontFamily: 'Montserrat, sans-serif',
          letterSpacing: '-0.01em',
          color: 'text.primary',
        }}>
        Receipt sent
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        You&rsquo;re all set.
      </Typography>
    </Stack>
  );
}
